import { gridSizeMdLg12 } from "@/shared";

import { CircularProgress, Dialog, DialogContentText, Grid,  useTheme } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";


interface CircularProgressProps {
  open: boolean;
  onClose?: () => void;
  message: string;
  ///size?: number;
  backdropColor?: string;
  progressColor?: "primary" | "secondary" | "inherit" | "success" | "error" | "info";
  thickness?: number; // tamaño de prosgreeCircular
  animateText?: boolean;
  puntoAnimado?: boolean;
  minWidt?: string | number,
  minHeight?: string | number,
  width?: string | number,
  height?: string | number,
}
const CustomCircularProgress: React.FC<CircularProgressProps> = ({
  open,
  onClose,
  message,
  //size = 80,
  backdropColor = "rgba(40, 44, 52, 0.85)",
  progressColor = "primary",
  thickness,
  animateText = false,
  puntoAnimado = false,
  minWidt = "45%", //minomo para peqñas
  minHeight = "35%",
  width = "100%",
  //height = '100%'

}) => {
  const theme = useTheme()

  //state
  const [textoAnimado, setTextoAnimado] = useState('')
  const [puntosAnimados, setPuntosAnimados] = useState('')

  //almacena el estado interno de la animacion
  const animationState = useRef({
    phase: "writing" as "writing" | "addingDots",
    charIndex: 0,
    timeout: null as NodeJS.Timeout | null
  })
  //*
  useEffect(() => {
    if (!animateText && open && puntoAnimado) {
      const interval = setInterval(() => {
        setPuntosAnimados(prev => prev.length >= 3 ? '' : prev + '.')
      }, 400)
      return () => clearInterval(interval)
    } else {
      setPuntosAnimados('')
    }
  }, [animateText, open, puntoAnimado])
  //*useEffect
  useEffect(() => {
    //limpia la animacion
    const limpiarAnimacion = () => {
      if (animationState.current.timeout)
        return clearTimeout(animationState.current.timeout)
    }
    //limepia cuando cieero el modal
    if (!open) {
      limpiarAnimacion(); //limpia el timeout actual
      setTextoAnimado(''), //  Reinicia  el texto visible
        setPuntosAnimados(''),
        animationState.current = {
          phase: "writing",
          charIndex: 0,
          timeout: null
        };
      return limpiarAnimacion
    }
    //seteamos el mensaje 
    if (!animateText) {
      setTextoAnimado(message) // muestra el mensaje completa inmediatamente
      return limpiarAnimacion;
    }
    //** */ AnimacionTextoEnSecuencia

    const animacionTextoEnSecuencia = () => {
      if (animationState.current.phase === "writing") {
        if (animationState.current.charIndex < message.length) {
          setTextoAnimado(message.substring(0, animationState.current.charIndex + 1));
          animationState.current.charIndex++;
          animationState.current.timeout = setTimeout(animacionTextoEnSecuencia, 60)
          return;
        }
        animationState.current.phase = "addingDots"
        setPuntosAnimados("");
        animacionTextoEnSecuencia();
      } else {
        setPuntosAnimados(prevActual => {
          if (prevActual.length >= 4) {
            animationState.current = {
              phase: 'writing',
              charIndex: 0,
              timeout: null,
            }
            setTextoAnimado('');
            return '';
          }
          return prevActual + ".";
        });
        animationState.current.timeout = setTimeout(animacionTextoEnSecuencia, 500);
      }
    }
    animacionTextoEnSecuencia();
    return limpiarAnimacion;
  }, [open, message, animateText])

  //**Estilo para texto */
  const estiloMensaje = useMemo(() => ({
    color: 'inherit',
    fontFamily: 'sans-serif',
    Typography: 'body1',
    whiteSpace: 'pre-line', /// salto de linea
    overflowWrap: 'break-word',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    Padding: 2,
    borderRadius: 2,
    //backgroundColor: 'background.paper',
    boxShadow: 1, // Sombra sutil
  }), [])

  //*style for modal transition
  const paperProps = useMemo(() => ({
    sx: {
      borderRadius: 4,
      backgroundColor: backdropColor,
      color: theme.palette.common.white,
      width: width,
      minWidt: minWidt,
      minHeight: minHeight,
      padding: 3,

    }
  }), [backdropColor, theme, width, minHeight, minWidt])
  //* CircularProgress
  const dialogContenido = useMemo(() => (

    <Grid container spacing={2} justifyContent={"space-between"} alignItems={"center"} >
      <Grid item {...gridSizeMdLg12} alignContent={'center'} textAlign={'center'}>
        <CircularProgress
          color={progressColor}
          size={'55%'}
          thickness={thickness}
        />

      </Grid>

      <Grid item {...gridSizeMdLg12} alignContent={'center'} textAlign={'center'}
      >
        <DialogContentText sx={estiloMensaje} aria-live="polite"
        >
          <Grid item {...gridSizeMdLg12}>

            {animateText && (
              <>
                {textoAnimado}
                {puntosAnimados}
              </>

            )}
            {puntoAnimado && (
              <>
                {message}
                <span style={{ fontSize: '1.5rem' }}>{puntosAnimados}</span>
              </>
            )}
            {!puntoAnimado && !animateText && (
              <>
                {message}
              </>

            )}

          </Grid>


        </DialogContentText>

      </Grid >
    </Grid >

  ), [progressColor, thickness, animateText, textoAnimado, puntosAnimados, message])



  return (
    <Dialog
      open={open}
      onClose={onClose || (() => { })}
      PaperProps={paperProps}
    //hideBackdrop 
    >
      {dialogContenido}
    </Dialog>
  )
}
export default CustomCircularProgress